import {useCallback} from 'react';
import {sendCrmMessage} from '../../../redux/crm/crmActions';
import {UseSendProps} from '../../../hooks/sendHooks.types';

export const useCrmSend = ({whatsappData, emailData, smsData, show}: UseSendProps) => {
    const handleSend = useCallback(async (type: string, trialRecipients?: string[]) => {
        const data = {
            whatsapp: whatsappData,
            email: emailData,
            sms: smsData,
        };
        try {
            await sendCrmMessage(type, {
                ...data[type], 
                ...(trialRecipients ? {trialRecipients} : {})
            });
            return true;

        } catch (error) {
            console.error('Failed to send crm:', error);
            show.close();
            return false;
        }
    }, [whatsappData, emailData, smsData]);

    return {handleSend};
};

